import { ListValueModel } from './list-value.model';
import { BaseModel } from './base.model';

export class ListModel extends BaseModel {

    name: string;
    list_type: number;
    integration_id: number;

    // Associations
    values: ListValueModel[];

    // local
    index: number;

    static validate(list: ListModel): boolean {
        return !!(list.name);
    }

    constructor(list?: ListModel) {
        super();

        this.name = list ? list.name || null : null;
        this.list_type = list ? list.list_type || 0 : 0;
        this.integration_id = list ? list.integration_id || 0 : 0;

        this.index = list ? list.index || 0 : 0;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/list.model.ts